var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1DistancePiloting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.32 15.61l-2.64 3a32.58 32.58 0 00-42.88 0l-2.63-3a36.58 36.58 0 0148.15 0zM58 53v12a4 4 0 01-4 4h-7a4 4 0 01-4-4V53a4 4 0 014-4h7a4 4 0 014 4zm-4 0h-7v12h7V53zm-.54-29.63l2.44-3.17a29 29 0 00-35.32 0L23 23.37a24.94 24.94 0 0130.43 0h.03zM28 35h20v11h4V35a4.26 4.26 0 00-4.08-4H27.83A4 4 0 0024 34.73c-.005.09-.005.18 0 .27v30c.005.208.025.415.06.62A4 4 0 0027.78 69H40v-4H28V35zm20.22-4h-.14.14zm-19.63-7.44l1.77 3.59a17.88 17.88 0 0115.76 0l1.77-3.59a21.91 21.91 0 00-19.3 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Distance_piloting.ceb27648.svg";
export { SvgG1DistancePiloting as ReactComponent };